export default __webpack_public_path__ + "static/media/Piping_Plover_5_grey.b4023fba.png";